import { get } from "lodash";
import { headers } from "../constants/headers";
export default function getTraceIdFromError(err) {
    return (getNormalResponse(err, headers.correlationId) ||
        getGraphResponse(err, headers.correlationId) ||
        getNormalResponse(err, headers.xAmzRequestId) ||
        getGraphResponse(err, headers.xAmzRequestId) ||
        null);
}
function getNormalResponse(err, header) {
    return get(err, "response.headers[" + header + "]");
}
function getGraphResponse(res, header) {
    return get(res, "headers[" + header + "]");
}
